<template>
  <a-icon type="line" :style="style()" class="j-slash" />
  <!--<span class="mdi mdi-slash-forward j-slash" :style="style()"></span>-->
</template>

<script>
export default {
  props: {
    color: {
      type: String,
    },
    top: {
      type: Number,
    },
  },
  methods: {
    style() {
      var sb = new StringBuilder()
      if (this.color) {
        sb.append('color: ' + this.color)
      }
      if (this.top) {
        sb.append('top: ' + this.top + 'px')
      }
      return sb.toString()
    },
  },
}
</script>
<style>
.j-slash {
  position: relative;
  margin: 0 3px 0 3px;
  top: 1px;
  color: #e8e8e8;
  vertical-align: -1px;
  font-size: 13px;
  transform: rotate(-70deg);
}

.ant-descriptions-title .j-slash {
  margin: 0 6px 0 2px;
  color: #d8d8d8;
}

.ant-descriptions-item-label .j-slash {
  color: #d8d8d8;
  /*top: 1px;*/
}

.ant-form-item-children .j-slash {
  /*top: 1px;*/
}
</style>
